import React from 'react';
import classnames from 'classnames';
import './Container.scss';

type ContainerProps = {
    className?: string;
    variant?:
        'normal' | 'narrow' | 'modal-narrow' | 'small' | 'mobile-medium-padding' | 'mobile-no-padding' | 'no-padding';
    width?: 'page';
};

export const Container: React.FC<React.PropsWithChildren<ContainerProps>> = ({
    children,
    className,
    variant = 'normal',
}) => {
    return (
        <div
            className={classnames({
                ['container']: true,
                ['containerNarrow']: variant === 'narrow',
                ['containerSmall']: variant === 'small',
                ['containerModalNarrow']: variant === 'modal-narrow',
                ['containerMobileMediumPadding']: variant === 'mobile-medium-padding',
                ['containerNoMobilePadding']: variant === 'mobile-no-padding',
                ['containerNoPadding']: variant === 'no-padding',
                [className || '']: true,
            })}
        >
            {children}
        </div>
    );
};
